module.exports = __webpack_public_path__ + "img/智美颜和.133841d.png";